import { ButtonLink } from "design-system/atoms/Button"
import { Progress } from "design-system/atoms/Progress"
import { Card, CardFooter, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Pulse } from "modules/shared/components/Miscelanea/Pulse"
import { useGetSubscription } from "modules/subscription/hooks/useGetSubscription"
import { useTranslation } from "react-i18next"

type Props = {
  usedAddonCredits: number
  totalAddonCredits: number
  addonIsError: boolean
  hasAddon: boolean
  autoTopupEnabled?: boolean
}

export function AddonUsage({
  usedAddonCredits,
  totalAddonCredits,
  addonIsError,
  hasAddon,
  autoTopupEnabled,
}: Props) {
  const { t } = useTranslation()

  const { data: subscription } = useGetSubscription()

  return (
    <Card>
      <CardHeader className="flex flex-row justify-between items-start w-full min-h-24">
        <div className="flex flex-col gap-1">
          <CardTitle>{t("subscription.usage.addon")}</CardTitle>
          {!autoTopupEnabled && (
            <div className="flex flex-col gap-1 items-start w-full text-muted-foreground text-sm">
              <span>{t("subscription.usage.noAutoTopup")}</span>
            </div>
          )}
          {autoTopupEnabled && (
            <div className="flex flex-col gap-1 items-start w-full text-muted-foreground text-sm">
              <span>{t("subscription.usage.autoTopupConfigured")}</span>
            </div>
          )}
        </div>
        <ButtonLink variant="outline" to="/settings/subscription/usage/configure-topups">
          {subscription?.autoTopUpPriceId
            ? t("subscription.usage.autoTopupEnabled")
            : t("subscription.usage.setupAutoTopup")}
          {subscription?.autoTopUpPriceId && <Pulse />}
        </ButtonLink>
      </CardHeader>
      <CardFooter className="flex flex-col justify-between items-start gap-3">
        {hasAddon && (
          <div className="flex flex-col gap-1 items-start w-full">
            <Progress
              value={usedAddonCredits}
              max={totalAddonCredits}
              color={addonIsError ? "destructive" : "gradient"}
              className="h-3"
            />
            <div className="flex flex-row justify-between w-full text-lg items-center font-mono">
              <span className="text-foreground">{usedAddonCredits}</span>
              <span className="text-muted-foreground">{totalAddonCredits}</span>
            </div>
          </div>
        )}
        {!hasAddon && (
          <div className="flex flex-col gap-1 items-start w-full text-muted-foreground text-sm opacity-10">
            <Progress value={0} max={1} color="primary" className="h-3" />
            <div className="flex flex-row justify-between w-full text-lg items-center font-mono text-muted-foreground">
              <span>{"0"}</span>
              <span className="text-foreground">{"100"}</span>
            </div>
          </div>
        )}
        <div className="flex flex-col gap-1 items-start w-full text-muted-foreground text-sm">
          <span>{t("subscription.usage.addonExplanation.first")}</span>
        </div>
      </CardFooter>
    </Card>
  )
}
